import { getCountryLanguage } from '@repo/utils';

import { TELEMETRY_LOGS, logTelemetry } from '@/lib/telemetry.lib';

import { getAppConfig } from '@/utils/window.utils';

export const modifyAsset = (assetType: string, assetId: string) => {
    const config = getAppConfig();
    const { country, language } = getCountryLanguage();
    const assetTypePath = assetType === 'quote' ? 'quotation' : assetType;

    logTelemetry('info', TELEMETRY_LOGS.AssetModifyRedirectedToCart, {
        asset: {
            type: assetType,
        },
    });
    globalThis.location.href = `${config.cartDomain}/${country}/${language}/${config.cartPath}/${assetTypePath}/${assetId}`;
};
